import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Louisiana Blue Cross and Blue Shield",
  shortName: "Louisiana Blue",
  slug: "la-blue-insurance",
  seoTitle:
    "Louisiana Blue Cross and Blue Shield TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Louisiana Blue Cross and Blue Shield policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Louisiana Blue TMS coverage, LA Blue Cross Blue Shield SPRAVATO authorization, Louisiana Blue mental health benefits Coral Springs FL, Louisiana Blue depression treatment Florida",
};

export const LaBlueInsurance = () => <InsurancePageTemplate config={config} />;
export default LaBlueInsurance;
